import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import deepEqual from 'deep-eql';
import shallowEqual from '../utils/shallowEqual';
import { CHANGE_TOPIC, WITH_OUT_DISPATCH } from './types';

var _default =
/*#__PURE__*/
function () {
  function _default() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, _default);

    this.distinct = void 0;
    this.prediction = void 0;
    this.onChange = void 0;
    this.limit = void 0;
    this.separator = void 0;
    this.$events = void 0;
    this.$cachedDisabled = void 0;
    this.$cachedFlatten = void 0;
    this.valueMap = void 0;
    this.disabled = void 0;
    this.format = void 0;
    this.$values = void 0;
    this.$cachedValue = void 0;
    this.updateLock = void 0;
    var format = args.format,
        onChange = args.onChange,
        separator = args.separator,
        value = args.value,
        prediction = args.prediction,
        distinct = args.distinct,
        disabled = args.disabled,
        limit = args.limit;
    this.distinct = distinct;
    this.limit = limit;
    this.separator = separator;
    this.initFormat(format);
    this.$events = {};
    this.$cachedDisabled = {};
    this.$cachedFlatten = new Map();
    this.setDisabled(disabled);
    if (prediction) this.prediction = prediction;
    this.setValue(value, WITH_OUT_DISPATCH);
    this.onChange = onChange;
  }

  _createClass(_default, [{
    key: "cleanDataCache",
    // should clean $cachedFlatten when data changed
    value: function cleanDataCache() {
      this.$cachedFlatten = new Map();
    }
  }, {
    key: "resetValueMap",
    value: function resetValueMap() {
      var map = new Map();

      for (var i = 0; i < this.$values.length; i++) {
        map.set(this.$values[i], true);
      }

      this.valueMap = map;
    }
  }, {
    key: "setDisabled",
    value: function setDisabled(disabled) {
      if (this.$cachedDisabled === disabled) return;
      this.$cachedDisabled = disabled;

      this.disabled = function (data) {
        switch (typeof disabled) {
          case 'boolean':
            return disabled;

          case 'function':
            for (var _len = arguments.length, obj = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              obj[_key - 1] = arguments[_key];
            }

            return disabled.apply(void 0, [data].concat(obj));

          default:
            return false;
        }
      };
    }
  }, {
    key: "handleChange",
    value: function handleChange(values) {
      this.$values = values;
      this.resetValueMap();
      this.dispatch(CHANGE_TOPIC);

      if (this.onChange) {
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        this.onChange.apply(this, [this.getValue()].concat(args));
      }
    }
  }, {
    key: "flattenTreeData",
    value: function flattenTreeData(data, childrenKey) {
      var _this = this;

      var keys = data.map(function (v) {
        return _this.format(v);
      }).map(function (v) {
        return typeof v === 'object' ? JSON.stringify(v) : v;
      });
      var key = keys.join();

      if (keys.length !== 0) {
        var cached = this.$cachedFlatten.get(key);
        if (cached) return cached;
      }

      var flatten = [];

      var deepAdd = function deepAdd(items) {
        items.forEach(function (item) {
          var exist = flatten.find(function (raw) {
            return _this.prediction ? _this.prediction(raw, item) : _this.format(raw) === _this.format(item);
          });
          if (!exist) flatten.push(item);
          if (item[childrenKey]) deepAdd(item[childrenKey]);
        });
      };

      deepAdd(data);
      if (keys.length) this.$cachedFlatten.set(key, flatten);
      return flatten;
    }
  }, {
    key: "setLock",
    value: function setLock(lock) {
      this.updateLock = lock;
    }
  }, {
    key: "add",
    value: function add(data, _, childrenKey, unshift) {
      var _this2 = this;

      if (data === undefined || data === null) return; // clear value

      if (this.limit === 1) this.$values = [];
      this.resetValueMap();
      var raws = Array.isArray(data) ? data : [data];

      if (childrenKey && this.limit !== 1) {
        raws = this.flattenTreeData(raws, childrenKey);
      }

      raws = raws.filter(function (v) {
        var disabled = _this2.disabled(v);

        if (disabled) return false;
        if (_this2.distinct) return !_this2.check(v);
        return true;
      });
      var values = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = raws[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var r = _step.value;
          var v = this.format(r);
          if (v !== undefined) values.push(v);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.handleChange(unshift ? values.concat(this.values) : this.values.concat(values), data, true);
    }
  }, {
    key: "set",
    value: function set(value) {
      this.$values = [];
      this.resetValueMap();
      this.add(value);
    }
  }, {
    key: "check",
    value: function check(raw) {
      if (this.prediction) {
        for (var i = 0, count = this.values.length; i < count; i++) {
          if (this.prediction(this.values[i], raw)) return true;
        }

        return false;
      }

      return !!this.valueMap.get(this.format(raw));
    }
  }, {
    key: "getDataByValue",
    value: function getDataByValue(data, value) {
      var _this3 = this;

      if (this.prediction) {
        for (var i = 0, count = data.length; i < count; i++) {
          if (this.prediction(value, data[i])) return data[i];
        }

        return null;
      }

      return data.find(function (d) {
        return value === _this3.format(d);
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      this.values = [];
    }
  }, {
    key: "dispatch",
    value: function dispatch(name) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      var event = this.$events[name];
      if (!event) return;
      event.forEach(function (fn) {
        return fn.apply(void 0, args);
      });
    }
  }, {
    key: "initFormat",
    value: function initFormat(f) {
      switch (typeof f) {
        case 'string':
          this.format = function (value) {
            return value[f];
          };

          break;

        case 'function':
          this.format = function (value) {
            return f(value);
          };

          break;

        default:
          this.format = function (a) {
            return a;
          };

          break;
      }
    }
  }, {
    key: "defaultPrediction",
    value: function defaultPrediction(value, data) {
      return value === this.format(data);
    }
  }, {
    key: "remove",
    value: function remove(value, _, childrenKey) {
      var _this4 = this;

      if (value === undefined || value === null) return;
      var raws = Array.isArray(value) ? value : [value];

      if (childrenKey) {
        raws = this.flattenTreeData(raws, childrenKey);
      }

      raws = raws.filter(function (r) {
        return !_this4.disabled(r);
      });
      var values = [];

      if (!this.prediction) {
        var rowValueMap = new Map();

        for (var i = 0; i < raws.length; i++) {
          if (raws[i].IS_NOT_MATCHED_VALUE) {
            rowValueMap.set(raws[i].value, true);
          } else {
            rowValueMap.set(this.format(raws[i]), true);
          }
        }

        for (var _i = 0; _i < this.values.length; _i++) {
          var val = this.values[_i];

          if (!rowValueMap.get(val)) {
            values.push(val);
          }
        }
      } else {
        var prediction = this.prediction;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          outer: for (var _iterator2 = this.values[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _val = _step2.value;

            for (var j = 0; j < raws.length; j++) {
              if (raws[j].IS_NOT_MATCHED_VALUE && _val === raws[j].value || prediction(_val, raws[j])) {
                raws.splice(j, 1);
                continue outer;
              }
            }

            values.push(_val);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } // this.values = values


      this.handleChange(values, value, false);
    }
  }, {
    key: "subscribe",
    value: function subscribe(name, fn) {
      if (!this.$events[name]) this.$events[name] = [];
      var events = this.$events[name];
      if (events.includes(fn)) return;
      events.push(fn);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(name, fn) {
      if (!this.$events[name]) return;
      this.$events[name] = this.$events[name].filter(function (e) {
        return e !== fn;
      });
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var value = this.values; // eslint-disable-next-line

      if (this.limit === 1) value = this.values[0];else if (this.separator) value = this.values.join(this.separator);
      this.$cachedValue = value;
      return value;
    }
  }, {
    key: "resetValue",
    value: function resetValue(values, cached) {
      this.$values = values;
      this.resetValueMap();

      if (this.onChange && !cached) {
        this.onChange(this.getValue());
      }

      this.dispatch(CHANGE_TOPIC);
      this.dispatch('set-value');
    }
  }, {
    key: "formatValue",
    value: function formatValue(values) {
      if (this.limit === 1 && !Array.isArray(values)) {
        return [values];
      }

      if (!values) return [];

      if (Array.isArray(values)) {
        return values;
      }

      if (typeof values === 'string') {
        if (this.separator) {
          return values.split(this.separator).map(function (s) {
            return s.trim();
          });
        }

        console.warn('Select separator parameter is empty.');
        return [values];
      }

      console.error(new Error('Select values is not valid.'));
      return [];
    }
  }, {
    key: "setValue",
    value: function setValue() {
      var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var type = arguments.length > 1 ? arguments[1] : undefined;
      if (deepEqual(values, this.$values)) return;

      if (type === WITH_OUT_DISPATCH) {
        this.$values = this.formatValue(values);
        this.resetValueMap();
      } else {
        this.resetValue(this.formatValue(values), shallowEqual(this.$cachedValue, values, {}));
      }

      this.$cachedValue = this.getValue();
    }
  }, {
    key: "length",
    get: function get() {
      return this.$values.length;
    }
  }, {
    key: "values",
    get: function get() {
      return this.$values;
    },
    set: function set(values) {
      this.$values = values;
      this.resetValueMap();
      this.dispatch(CHANGE_TOPIC);

      if (this.onChange) {
        this.onChange(this.getValue());
      }
    }
  }]);

  return _default;
}();

export { _default as default };